import React from 'react'

const SummarySetting: React.FC<{ setting?: any, locale: string }> = ({ setting, locale }) => {
    return (
        <>
            {setting.message && <div className="text-start"><p className="small text-muted">{setting.message}</p></div>}
            {setting?.linked && <a className="d-block text-decoration-none btn btn-primary text-light" target={setting?.linked?.type}
                href={setting?.linked?.type === "_self" ? `/${locale}/${setting.linked.href}/` : `${locale}/${setting?.linked?.href}`}>{setting?.linked?.text}</a>}
        </>
    )
}

export default SummarySetting